import { Injectable } from '@angular/core';

const padding = '000000';

@Injectable({
  providedIn: 'root',
})
export class CurrenyTransformService {
  private prefix = '$';
  private decimalSeparator = '.';
  private thousandsSeparator = ',';
  private suffix = '';

  currencyTransform(value: string, fractionSize: number = 0): string {
    value = value.replace('$', '').replace(',', '').replace(/\,/g, '');
    if (parseFloat(value) % 1 !== 0) {
      fractionSize = 2;
    }
    let [integer, fraction = ''] = (parseFloat(value).toString() || '').toString().split('.');

    fraction =
      fractionSize > 0
        ? this.decimalSeparator + (fraction + padding).slice(0, Math.max(0, fractionSize))
        : '';
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    if (isNaN(parseFloat(integer))) {
      integer = '0';
    }
    return this.prefix + integer + fraction + this.suffix;
  }

  parse(value: string, fractionSize: number = 2): string {
    let [integer, fraction = ''] = (value || '')
      .replace(this.prefix, '')
      .replace(this.suffix, '')
      .split(this.decimalSeparator);

    integer = integer.replace(new RegExp(this.thousandsSeparator, 'g'), '');

    fraction =
      parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.decimalSeparator + (fraction + padding).slice(0, Math.max(0, fractionSize))
        : '';

    return integer + fraction;
  }
}
